import React from 'react';

import SuggestedHashtagList from 'components/suggestedHashtag/suggestedHashtagList';

const SuggestedHashtags = () => <SuggestedHashtagList />;

export default SuggestedHashtags;
